<template>
  <el-container>
    <el-main>
      <div class="tabs-container">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane label="解析管理" name="parse-manage">
            <ResultMgr/>
          </el-tab-pane>

          <el-tab-pane label="MI解析" name="mi-parse">
            <FileUpload/>
          </el-tab-pane>

          <el-tab-pane label="解压文件" name="file-tree">
            <UncompressPackage/>
          </el-tab-pane>

          <el-tab-pane label="远程查看" name="debug-mgr">
            <DebugGmr/>
          </el-tab-pane>

        </el-tabs>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue';
import ResultMgr from '@/components/ResultMgr.vue';
import  DebugGmr from '@/components/DebugGmr.vue';
import UncompressPackage from '@/components/UncompressPackage.vue';

export default {
  name: 'MainView',
  components: {
    FileUpload,
    ResultMgr,
    UncompressPackage,
    DebugGmr
  },
  data() {
    return {
      activeTab: 'mi-parse',  // 默认选中 MI解析
    };
  },
  methods: {
    handleTabClick(tab) {
      console.log('当前选中的标签:', tab.name);
    },
  },
};
</script>

<style scoped>
.el-container {
  height: calc(100vh - 60px); /* 顶部栏高度为60px */
  background: rgb(247, 248, 250);
}

.el-main {
  padding: 20px;
}

/* 调整 el-tabs 的容器 */
.tabs-container {
  margin: 0 50px; /* 水平居中 */
}

/* 让“解析管理”略微往中间靠 */
.el-tabs__header {
  padding-left: 20px; /* 调整为适当的缩进值 */
}
</style>
